<template>
  <wd-popup
    v-model="loginStore.showLoginPopup"
    custom-style="background-color: transparent"
    :class="themeStore.theme"
    @close="handleClose"
  >
    <view class="absolute top-16px right-16px" @click="handleClose">
      <image
        class="w-16px h-16px"
        :src="themeStore.theme === 'light' ? CloseB : CloseW"
        mode="scaleToFill"
      />
    </view>
    <view class="page w-95vw py-16 px-15 overflow-y-auto bg-navigate-bg rounded-12px login-popup">
      <view class="w-full">
        <view
          class="p-4px rounded-12px flex justify-between items-center w-fit text-white switch-bar mb-20px"
        >
          <view
            class="text-14px px-10px rounded-8px leading-36px"
            :class="{ active: loginType === 'login' }"
            @click="changeLoginType('login')"
          >
            {{ $t('login.login') }}
          </view>
          <view
            class="text-14px px-10px rounded-8px leading-36px"
            :class="{ active: loginType === 'register' }"
            @click="changeLoginType('register')"
          >
            {{ $t('login.register') }}
          </view>
        </view>
        <view class="w-full flex justify-center">
          <img src="@/static/images/navigate/logo-1.png" alt="" class="w-75px h-75px mx-auto" />
        </view>
        <template v-if="loginType === 'login'">
          <form>
            <view class="w-full pt-20px flex flex-col login-form">
              <view class="w-full flex items-center rounded-8px px-10px py-12px login-input">
                <input
                  class="text-14px w-full"
                  type="text"
                  v-model="loginForm.name"
                  :placeholder="$t('login.username')"
                  @input="clearLoginError('name')"
                />
              </view>
              <view v-if="loginErrors.name" class="text-12px text-red-500 mt-1 ml-2">
                {{ loginErrors.name }}
              </view>
              <view
                class="w-full flex items-center rounded-8px px-10px py-12px mt-12px login-input"
              >
                <input
                  class="text-14px flex-1"
                  :type="showLoginPassword ? 'text' : 'password'"
                  v-model="loginForm.pwd"
                  :placeholder="$t('login.password')"
                  @input="clearLoginError('pwd')"
                />
                <image
                  class="w-18px h-18px flex-shrink-0 ml-10px cursor-pointer"
                  :src="showLoginPassword ? EyeOpen : EyeClose"
                  mode="aspectFit"
                  @click="showLoginPassword = !showLoginPassword"
                />
              </view>
              <view v-if="loginErrors.pwd" class="text-12px text-red-500 mt-1 ml-2">
                {{ loginErrors.pwd }}
              </view>
              <view class="w-full flex items-center mt-12px">
                <view class="w-full flex items-center rounded-8px px-10px py-12px login-input">
                  <input
                    class="text-14px w-full"
                    type="text"
                    v-model="loginForm.code"
                    :placeholder="$t('login.captcha')"
                    @input="clearLoginError('code')"
                  />
                </view>
                <view class="ml-10px w-120px h-40px">
                  <img
                    v-if="loginCaptcha.picPath"
                    :src="loginCaptcha.picPath"
                    alt=""
                    class="w-full h-full bg-white"
                    @click="getLoginCaptchaCode"
                  />
                </view>
              </view>
              <view v-if="loginErrors.code" class="text-12px text-red-500 mt-1 ml-2">
                {{ loginErrors.code }}
              </view>
            </view>
          </form>
        </template>
        <template v-if="loginType === 'register'">
          <form>
            <view class="w-full pt-20px flex flex-col login-form">
              <view class="w-full flex items-center rounded-8px px-10px py-12px login-input">
                <input
                  class="text-14px w-full"
                  type="text"
                  v-model="registerForm.name"
                  :placeholder="$t('login.username')"
                  @input="clearRegisterError('name')"
                />
              </view>
              <view v-if="registerErrors.name" class="text-12px text-red-500 mt-1 ml-2">
                {{ registerErrors.name }}
              </view>
              <view
                class="w-full flex items-center rounded-8px px-10px py-12px mt-12px login-input"
              >
                <input
                  class="text-14px w-full"
                  :type="showRegisterPassword ? 'text' : 'password'"
                  v-model="registerForm.pwd"
                  :placeholder="$t('login.password')"
                  @input="clearRegisterError('pwd')"
                />
                <image
                  class="w-18px h-18px flex-shrink-0 ml-10px cursor-pointer"
                  :src="showRegisterPassword ? EyeOpen : EyeClose"
                  mode="aspectFit"
                  @click="showRegisterPassword = !showRegisterPassword"
                />
              </view>
              <view v-if="registerErrors.pwd" class="text-12px text-red-500 mt-1 ml-2">
                {{ registerErrors.pwd }}
              </view>
              <view
                class="w-full flex items-center rounded-8px px-10px py-12px mt-12px login-input"
              >
                <input
                  class="text-14px w-full"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  v-model="registerForm.confirmPwd"
                  :placeholder="$t('login.confirmPassword')"
                  @input="clearRegisterError('confirmPwd')"
                />
                <image
                  class="w-18px h-18px flex-shrink-0 ml-10px cursor-pointer"
                  :src="showConfirmPassword ? EyeOpen : EyeClose"
                  mode="aspectFit"
                  @click="showConfirmPassword = !showConfirmPassword"
                />
              </view>
              <view v-if="registerErrors.confirmPwd" class="text-12px text-red-500 mt-1 ml-2">
                {{ registerErrors.confirmPwd }}
              </view>
              <view class="w-full flex items-center mt-12px">
                <view class="w-full flex items-center rounded-8px px-10px py-12px login-input">
                  <input
                    class="text-14px w-full"
                    type="text"
                    v-model="registerForm.code"
                    :placeholder="$t('login.captcha')"
                    @input="clearRegisterError('code')"
                  />
                </view>
                <view class="ml-10px w-120px h-40px">
                  <img
                    v-if="registerCaptcha.picPath"
                    :src="registerCaptcha.picPath"
                    alt=""
                    class="w-full h-full bg-white"
                    @click="getRegisterCaptchaCode"
                  />
                </view>
              </view>
              <view v-if="registerErrors.code" class="text-12px text-red-500 mt-1 ml-2">
                {{ registerErrors.code }}
              </view>
              <view
                class="w-full flex items-center rounded-8px px-10px py-12px login-input mt-12px"
              >
                <input
                  class="text-14px w-full"
                  type="text"
                  v-model="registerForm.inviteCode"
                  :placeholder="$t('login.inviteCode')"
                  @input="clearRegisterError('inviteCode')"
                />
              </view>
              <view v-if="registerErrors.inviteCode" class="text-12px text-red-500 mt-1 ml-2">
                {{ registerErrors.inviteCode }}
              </view>
            </view>
          </form>
        </template>
        <view
          class="warning-btn mt-20px"
          @click="loginType === 'login' ? handleLogin() : handleRegister()"
        >
          {{ loginType === 'login' ? $t('login.loginButton') : $t('login.registerButton') }}
        </view>
        <view class="w-full flex justify-center items-center mt-20px" @click="handleTgLogin">
          <img src="@/static/images/icon/tg-logo.png" alt="" class="w-35px h-35px mr-8px" />
          <text class="text-14px text-#007aff">{{ t('login.tgLogin') }}</text>
          <img src="@/static/images/common/arrow_right_b.png" alt="" class="w-16px h-16px ml-4px" />
        </view>
      </view>
    </view>
  </wd-popup>
</template>

<script lang="ts" setup>
import { useThemeStore, useUserStore } from '@/store'
import { useLoginStore } from '@/store/modules/login'
import { getLoginCode, getRegisterCode, postEmailRegister, postEmailLogin } from '@/service'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import EyeClose from '@/static/images/common/eye-close.png'
import EyeOpen from '@/static/images/common/view.png'
import CloseW from '@/static/images/common/close_w.png'
import CloseB from '@/static/images/common/close.png'

const { t } = useI18n()
const loginStore = useLoginStore()
const themeStore = useThemeStore()
const userStore = useUserStore()
const { isLogined } = storeToRefs(userStore)
const emit = defineEmits(['close', 'update:show', 'login-success'])
// const props = defineProps<{
//   type: 'login' | 'register'
// }>()

// const popupShow = ref(false)
// 封装一个方法把hash中的参数以对象的方式返回
const getHashParams = () => {
  const query = window.location.hash.split('?')[1]
  const params = new URLSearchParams(query)
  const paramsObj = Object.fromEntries(params)
  console.log(paramsObj, 'query111111')
  return paramsObj
}
const inviteCode = ref('')
watch(
  () => loginStore.showLoginPopup,
  (value) => {
    // popupShow.value = value
    // 当弹窗打开时，初始化数据
    if (value) {
      const query = getHashParams()
      inviteCode.value = query.inviteCode || ''
      console.log(inviteCode.value, 'inviteCode.value')
      // 重置密码显示状态
      showLoginPassword.value = false
      showRegisterPassword.value = false
      showConfirmPassword.value = false

      // 重置表单数据
      loginForm.name = ''
      loginForm.pwd = ''
      loginForm.code = ''

      registerForm.name = ''
      registerForm.pwd = ''
      registerForm.confirmPwd = ''
      registerForm.code = ''
      registerForm.inviteCode = inviteCode.value

      // 重置错误提示
      Object.keys(loginErrors).forEach((key) => {
        loginErrors[key as keyof typeof loginErrors] = ''
      })
      Object.keys(registerErrors).forEach((key) => {
        registerErrors[key as keyof typeof registerErrors] = ''
      })

      // 获取验证码
      if (isLogined.value) return
      if (loginType.value === 'login') {
        getLoginCaptchaCode()
      } else {
        getRegisterCaptchaCode()
      }
    }
  },
)

const loginType = ref<'login' | 'register'>('login')

// 添加密码显示状态控制
const showLoginPassword = ref(false)
const showRegisterPassword = ref(false)
const showConfirmPassword = ref(false)

// 获取登录验证码
const loginCaptcha = ref<any>({})
const getLoginCaptchaCode = async () => {
  try {
    const res = await getLoginCode()
    if (res.code === 0) {
      loginCaptcha.value = res.data
    } else {
      uni.showToast({
        title: res.msg,
        icon: 'none',
      })
    }
  } catch (error) {
    console.error('获取登录验证码失败:', error)
  }
}

// 获取注册验证码
const registerCaptcha = ref<any>({})
const getRegisterCaptchaCode = async () => {
  try {
    const res = await getRegisterCode()
    // console.log('获取注册验证码:', res)
    if (res.code === 0) {
      registerCaptcha.value = res.data
    } else {
      uni.showToast({
        title: res.msg,
        icon: 'none',
      })
    }
  } catch (error) {
    console.error('获取注册验证码失败:', error)
  }
}

watch(
  () => loginStore.loginType,
  (value) => {
    console.log('loginStore.loginType', value)

    loginType.value = value as 'login' | 'register'
    if (isLogined.value) return
    if (value === 'login') {
      getLoginCaptchaCode()
    } else {
      getRegisterCaptchaCode()
    }
  },
)

const changeLoginType = (type: 'login' | 'register') => {
  showLoginPassword.value = false
  showRegisterPassword.value = false
  showConfirmPassword.value = false
  loginType.value = type
  if (type === 'login') {
    // 清空表单
    loginForm.name = ''
    loginForm.pwd = ''
    loginForm.code = ''
    getLoginCaptchaCode()
  } else {
    // 清空表单
    registerForm.name = ''
    registerForm.pwd = ''
    registerForm.confirmPwd = ''
    registerForm.code = ''
    registerForm.inviteCode = inviteCode.value
    getRegisterCaptchaCode()
  }
}
const loginForm = reactive({
  name: '',
  pwd: '',
  code: '',
})

// 登录表单错误提示
const loginErrors = reactive({
  name: '',
  pwd: '',
  code: '',
})

const registerForm = reactive({
  name: '',
  pwd: '',
  confirmPwd: '',
  code: '',
  inviteCode: '',
})

// 注册表单错误提示
const registerErrors = reactive({
  name: '',
  pwd: '',
  confirmPwd: '',
  inviteCode: '',
  code: '',
})

// 清除登录错误提示
const clearLoginError = (field: keyof typeof loginErrors) => {
  loginErrors[field] = ''
}

// 清除注册错误提示
const clearRegisterError = (field: keyof typeof registerErrors) => {
  registerErrors[field] = ''
}

// 验证登录表单
const validateLoginForm = () => {
  let isValid = true

  // 验证用户名
  if (!loginForm.name) {
    loginErrors.name = t('login.errors.usernameRequired')
    isValid = false
  }
  const emailreg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (!emailreg.test(loginForm.name)) {
    registerErrors.name = t('login.errors.usernameLength')
    isValid = false
  }

  // 验证密码
  if (!loginForm.pwd) {
    loginErrors.pwd = t('login.errors.passwordRequired')
    isValid = false
  } else if (loginForm.pwd.length < 6) {
    loginErrors.pwd = t('login.errors.passwordLength')
    isValid = false
  }

  // 验证验证码
  if (!loginForm.code) {
    loginErrors.code = t('login.errors.captchaRequired')
    isValid = false
  }

  // 如果验证失败，刷新验证码
  if (!isValid) {
    getLoginCaptchaCode()
  }

  return isValid
}

// 验证注册表单
const validateRegisterForm = () => {
  let isValid = true

  // 验证用户名
  if (!registerForm.name) {
    registerErrors.name = t('login.errors.usernameRequired')
    isValid = false
  }
  const emailreg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (!emailreg.test(registerForm.name)) {
    registerErrors.name = t('login.errors.usernameLength')
    isValid = false
  }

  // 验证密码
  if (!registerForm.pwd) {
    registerErrors.pwd = t('login.errors.passwordRequired')
    isValid = false
  } else if (registerForm.pwd.length < 6) {
    registerErrors.pwd = t('login.errors.passwordLength')
    isValid = false
  }

  // 验证确认密码
  if (!registerForm.confirmPwd) {
    registerErrors.confirmPwd = t('login.errors.confirmPasswordRequired')
    isValid = false
  } else if (registerForm.confirmPwd !== registerForm.pwd) {
    registerErrors.confirmPwd = t('login.errors.passwordMismatch')
    isValid = false
  }

  // 验证验证码
  if (!registerForm.code) {
    registerErrors.code = t('login.errors.captchaRequired')
    isValid = false
  }

  // 验证邀请码
  // if (!registerForm.inviteCode) {
  //   registerErrors.inviteCode = t('login.errors.inviteCodeRequired')
  //   isValid = false
  // }

  // 如果验证失败，刷新验证码
  if (!isValid) {
    getRegisterCaptchaCode()
  }

  return isValid
}

// 登录处理
const handleLogin = async () => {
  if (!validateLoginForm()) {
    return
  }

  try {
    const res = await postEmailLogin({
      captcha: loginForm.code,
      captchaId: loginCaptcha.value.captchaId,
      email: loginForm.name,
      password: loginForm.pwd,
    })
    if (res.code === 0) {
      userStore.setToken(res.data.token)
      // const userInfo = await getUserInfo()
      userStore.updateUserInfo()
      uni.showToast({
        title: t('login.messages.loginSuccess'),
        icon: 'success',
      })
      emit('login-success')
      emit('close', false)
    } else {
      uni.showToast({
        title: res.msg || t('login.messages.loginFailed'),
        icon: 'none',
      })
      getLoginCaptchaCode()
      loginForm.code = ''
    }
  } catch (error) {
    uni.showToast({
      title: t('login.messages.loginFailed'),
      icon: 'error',
    })
    getLoginCaptchaCode()
    loginForm.code = ''
  }
}

// 注册处理
const handleRegister = async () => {
  if (!validateRegisterForm()) {
    return
  }

  try {
    const res = await postEmailRegister({
      captcha: registerForm.code,
      captchaId: registerCaptcha.value.captchaId,
      inviteCode: registerForm.inviteCode,
      email: registerForm.name,
      password: registerForm.pwd,
      siteId: Number(import.meta.env.VITE_APP_SITE_ID),
    })
    if (res.code === 0) {
      uni.showToast({
        title: t('login.messages.registerSuccess'),
        icon: 'success',
      })
      userStore.setToken(res.data.token)
      userStore.updateUserInfo()
      emit('login-success')
      emit('close', false)
      // changeLoginType('login')
      // loginForm.name = registerForm.name
    } else {
      uni.showToast({
        title: res.msg || t('login.messages.registerFailed'),
        icon: 'none',
      })
      getRegisterCaptchaCode()
      registerForm.code = ''
    }
  } catch (error) {
    uni.showToast({
      title: t('login.messages.registerFailed'),
      icon: 'error',
    })
    getRegisterCaptchaCode()
    registerForm.code = ''
  }
}

// 跳转tg登录
const handleTgLogin = () => {
  window.open(import.meta.env.VITE_TG_BOT_ADDRESS)
}

const handleClose = () => {
  emit('close', false)
}
</script>

<style scoped lang="scss">
.login-input {
  height: 48px;
}
</style>
